<template>
  <div class="tabs_content">
    <section v-if="idSubscriber">
      <restricted-channels-list
          :id-subscriber="idSubscriber" />
    </section>
  </div>
</template>

<script>
import RestrictedChannelsList from "./RestrictedChannelsList.vue";

export default {
  name: "SubscriberDetailRestrictedChannels",
  components: { RestrictedChannelsList },
  props: {
    entity: Object,
  },
  computed: {
    idSubscriber() {
      if (this.entity && 'id' in this.entity) {
        return this.entity.id;
      } else {
        return null;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/restrictedChannels/RestrictedChannels.vue